import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  flex-grow: 1;\n  background-color: ",
        ";\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _tagged_template_literal([
        "\n  max-width: 640px;\n  margin: 0 auto;\n  padding: 48px 20px;\n\n  @media (max-width: 1200px) {\n  }\n  @media (max-width: 768px) {\n    max-width: 390px;\n    padding: 24px 16px;\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-bottom: 40px;\n  font-size: 24px;\n  font-weight: 600;\n  line-height: 32px;\n  color: ",
        ";\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _tagged_template_literal([
        "\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 1.5;\n  letter-spacing: -0.16px;\n  color: ",
        ";\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = _tagged_template_literal([
        "\n  padding: 16px 24px;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 1.5;\n  letter-spacing: -0.16px;\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = _tagged_template_literal([
        "\n  margin-bottom: 0;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 22px;\n  letter-spacing: -0.14px;\n\n  &,\n  dd {\n    margin-bottom: 0;\n  }\n\n  dt {\n    margin-bottom: 8px;\n    color: ",
        ";\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 1.5;\n    letter-spacing: -0.16px;\n  }\n\n  li {\n    color: ",
        ";\n  }\n\n  ol {\n    margin-bottom: 0;\n    padding-left: 20px;\n\n    li {\n      list-style-type: decimal;\n    }\n  }\n\n  ul {\n    padding-left: 20px;\n\n    li {\n      list-style-type: disc;\n\n      &::marker {\n        content: '• ';\n      }\n    }\n  }\n"
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import FilledButton from "@/components/common/Button/FilledButton";
import { BOOKS_LANDING } from "@/settings/constant";
import { useRouter } from "next/router";
import { useMemo } from "react";
import styled from "styled-components";
export const BooksWrapper = styled.div.withConfig({
    componentId: "sc-3dad6aec-0"
})(_templateObject(), (props)=>props.theme.new.colors.sol_gray_0);
export const BooksContainer = styled.div.withConfig({
    componentId: "sc-3dad6aec-1"
})(_templateObject1());
export const BooksStyledTitle = styled.h2.withConfig({
    componentId: "sc-3dad6aec-2"
})(_templateObject2(), (props)=>props.theme.new.colors.sol_gray_900);
export const BooksSubtitle = styled.p.withConfig({
    componentId: "sc-3dad6aec-3"
})(_templateObject3(), (props)=>props.theme.new.colors.sol_gray_500);
export const OrderTitle = (param)=>{
    let { primary , secondary  } = param;
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: /*#__PURE__*/ _jsxs(BooksStyledTitle, {
            children: [
                primary,
                !!secondary && /*#__PURE__*/ _jsx(BooksSubtitle, {
                    children: secondary
                })
            ]
        })
    });
};
export const OrderFilledButton = styled(FilledButton).withConfig({
    componentId: "sc-3dad6aec-4"
})(_templateObject4());
export const TermsContainer = styled.dl.withConfig({
    componentId: "sc-3dad6aec-5"
})(_templateObject5(), (props)=>props.theme.new.colors.sol_gray_900, (props)=>props.theme.new.colors.sol_gray_500);
export const getIsBooks = (pathname)=>pathname.startsWith(BOOKS_LANDING);
export const useBooks = ()=>{
    const { pathname  } = useRouter();
    const { isBooks  } = useMemo(()=>{
        return {
            isBooks: getIsBooks(pathname)
        };
    }, [
        pathname
    ]);
    return {
        isBooks
    };
};
